import React from 'react';
import { Box, Card, Grid2 as Grid, useTheme } from '@mui/material';
import CocoConversationList from 'components/coco/CocoConversationList';
import CocoChat from 'components/coco/CocoChat';

export default function CocoPage() {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 80px)', maxWidth: '100%' }}>
      <Card sx={{ width: '100%', height: '100%', p: 2 }}>
        <Grid container sx={{ height: '100%', maxHeight: '100%' }}>
          <Grid size={3} sx={{ maxHeight: '100%' }}>
            <Box sx={{ height: '100%', maxHeight: '100%', overflowY: 'auto' }}>
              <CocoConversationList />
            </Box>
          </Grid>
          <Grid size={9} sx={{ maxHeight: '100%' }}>
            <Box
              sx={{
                ml: 2,
                height: '100%',
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                bgcolor: 'background.paper',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <CocoChat />
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
